export default {
  gridDataLoading: (state) => {
    return state.gridDataLoading;
  },
  gridData: (state) => {
    return state.gridData;
  },
  aGGridActionMenu: (state) => {
    return state.aGGridActionMenu;
  },
  selectedRowData: (state) => {
    return state.selectedRowData;
  },
};
